import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import PageHeader from '../../components/ui/PageHeader';
import DialogHeader from '../../components/ui/DialogHeader';
import ActionToolbar from '../../components/ui/ActionToolbar';
import { useAuth } from '../../context/AuthContext';
import { UrbanizacionEntity } from '../../entity/UrbanizacionEntity';
import { EtapaEntity } from '../../entity/EtapaEntity';
import { ManzanaEntity } from '../../entity/ManzanaEntity';
import { LoteEntity } from '../../entity/LoteEntity';
import { EstadoLoteOptions } from '../../entity/EstadoLote';
import { UrbanizacionService } from '../../service/UrbanizacionService';
import { EtapaService } from '../../service/EtapaService';
import { ManzanaService } from '../../service/ManzanaService';
import { LoteService } from '../../service/LoteService';
import '../Usuario.css';
import './Lotizacion.css';

import { exportarDesdeDataTable } from '../../utils/excelUtils';

const Lotizacion = () => {
    const { axiosInstance, user } = useAuth();
    const toast = useRef(null);
    const dtLote = useRef(null);

    const emptyUrbanizacion = { ...UrbanizacionEntity };
    const emptyEtapa = { ...EtapaEntity, urbanizacion: null };
    const emptyManzana = { ...ManzanaEntity, etapa: null };
    const emptyLote = { ...LoteEntity, manzana: null };

    const [urbanizaciones, setUrbanizaciones] = useState([]);
    const [urbanizacionRecords, setUrbanizacionRecords] = useState([]);
    const [urbanizacionTotalRecords, setUrbanizacionTotalRecords] = useState(0);
    const [urbanizacionPage, setUrbanizacionPage] = useState(0);
    const [urbanizacionRows, setUrbanizacionRows] = useState(6);
    const [urbanizacionLoading, setUrbanizacionLoading] = useState(false);
    const [urbanizacion, setUrbanizacion] = useState(emptyUrbanizacion);
    const [urbanizacionDialog, setUrbanizacionDialog] = useState(false);
    const [urbanizacionSubmitted, setUrbanizacionSubmitted] = useState(false);
    const [urbanizacionEdit, setUrbanizacionEdit] = useState(emptyUrbanizacion);
    const [urbanizacionFilter, setUrbanizacionFilter] = useState('');

    const [etapas, setEtapas] = useState([]);
    const [etapaRecords, setEtapaRecords] = useState([]);
    const [etapaTotalRecords, setEtapaTotalRecords] = useState(0);
    const [etapaPage, setEtapaPage] = useState(0);
    const [etapaRows, setEtapaRows] = useState(6);
    const [etapaLoading, setEtapaLoading] = useState(false);
    const [etapa, setEtapa] = useState(emptyEtapa);
    const [etapaDialog, setEtapaDialog] = useState(false);
    const [etapaSubmitted, setEtapaSubmitted] = useState(false);
    const [etapaEdit, setEtapaEdit] = useState(emptyEtapa);
    const [etapaFilter, setEtapaFilter] = useState('');
    const [etapaUrbanizacionFilter, setEtapaUrbanizacionFilter] = useState(null);

    const [manzanas, setManzanas] = useState([]);
    const [manzanaRecords, setManzanaRecords] = useState([]);
    const [manzanaTotalRecords, setManzanaTotalRecords] = useState(0);
    const [manzanaPage, setManzanaPage] = useState(0);
    const [manzanaRows, setManzanaRows] = useState(6);
    const [manzanaLoading, setManzanaLoading] = useState(false);
    const [manzana, setManzana] = useState(emptyManzana);
    const [manzanaDialog, setManzanaDialog] = useState(false);
    const [manzanaSubmitted, setManzanaSubmitted] = useState(false);
    const [manzanaEdit, setManzanaEdit] = useState(emptyManzana);
    const [manzanaFilter, setManzanaFilter] = useState('');
    const [manzanaUrbanizacionFilter, setManzanaUrbanizacionFilter] = useState(null);
    const [manzanaEtapaFilter, setManzanaEtapaFilter] = useState(null);
    const [manzanaFilterEtapas, setManzanaFilterEtapas] = useState([]);
    const [manzanaUrbanizacion, setManzanaUrbanizacion] = useState(null);
    const [manzanaEtapas, setManzanaEtapas] = useState([]);
    const [manzanaDialogUrbanizacion, setManzanaDialogUrbanizacion] = useState(null);
    const [manzanaDialogEtapas, setManzanaDialogEtapas] = useState([]);

    const [lotes, setLotes] = useState([]);
    const [loteRecords, setLoteRecords] = useState([]);
    const [loteTotalRecords, setLoteTotalRecords] = useState(0);
    const [lotePage, setLotePage] = useState(0);
    const [loteRows, setLoteRows] = useState(6);
    const [loteLoading, setLoteLoading] = useState(false);
    const [lote, setLote] = useState(emptyLote);
    const [loteDialog, setLoteDialog] = useState(false);
    const [loteSubmitted, setLoteSubmitted] = useState(false);
    const [loteEdit, setLoteEdit] = useState(emptyLote);
    const [loteFilter, setLoteFilter] = useState('');
    const [loteUrbanizacionFilter, setLoteUrbanizacionFilter] = useState(null);
    const [loteEtapaFilter, setLoteEtapaFilter] = useState(null);
    const [loteManzanaFilter, setLoteManzanaFilter] = useState(null);
    const [loteFilterEtapas, setLoteFilterEtapas] = useState([]);
    const [loteFilterManzanas, setLoteFilterManzanas] = useState([]);
    const [loteUrbanizacion, setLoteUrbanizacion] = useState(null);
    const [loteEtapa, setLoteEtapa] = useState(null);
    const [loteEtapas, setLoteEtapas] = useState([]);
    const [loteManzanas, setLoteManzanas] = useState([]);
    const [loteDialogUrbanizacion, setLoteDialogUrbanizacion] = useState(null);
    const [loteDialogEtapa, setLoteDialogEtapa] = useState(null);
    const [loteDialogEtapas, setLoteDialogEtapas] = useState([]);
    const [loteDialogManzanas, setLoteDialogManzanas] = useState([]);

    const urbanizacionOptions = urbanizaciones.map((item) => ({ label: item.nombre, value: item }));
    const manzanaFilterEtapaOptions = manzanaFilterEtapas.map((item) => ({ label: item.nombre, value: item }));
    const manzanaEtapaOptions = manzanaEtapas.map((item) => ({ label: item.nombre, value: item }));
    const manzanaDialogEtapaOptions = manzanaDialogEtapas.map((item) => ({ label: item.nombre, value: item }));
    const loteFilterEtapaOptions = loteFilterEtapas.map((item) => ({ label: item.nombre, value: item }));
    const loteFilterManzanaOptions = loteFilterManzanas.map((item) => ({ label: item.nombre, value: item }));
    const loteEtapaOptions = loteEtapas.map((item) => ({ label: item.nombre, value: item }));
    const loteManzanaOptions = loteManzanas.map((item) => ({ label: item.nombre, value: item }));
    const loteDialogEtapaOptions = loteDialogEtapas.map((item) => ({ label: item.nombre, value: item }));
    const loteDialogManzanaOptions = loteDialogManzanas.map((item) => ({ label: item.nombre, value: item }));

    const hideUrbanizacionDialog = () => {
        setUrbanizacionDialog(false);
        setUrbanizacionSubmitted(false);
        setUrbanizacionEdit(emptyUrbanizacion);
    };

    const hideEtapaDialog = () => {
        setEtapaDialog(false);
        setEtapaSubmitted(false);
        setEtapaEdit(emptyEtapa);
    };

    const hideManzanaDialog = () => {
        setManzanaDialog(false);
        setManzanaSubmitted(false);
        setManzanaEdit(emptyManzana);
        setManzanaDialogUrbanizacion(null);
        setManzanaDialogEtapas([]);
    };

    const hideLoteDialog = () => {
        setLoteDialog(false);
        setLoteSubmitted(false);
        setLoteEdit(emptyLote);
        setLoteDialogUrbanizacion(null);
        setLoteDialogEtapa(null);
        setLoteDialogEtapas([]);
        setLoteDialogManzanas([]);
    };

    const cargarUrbanizaciones = useCallback(async () => {
        try {
            const response = await UrbanizacionService.listar(axiosInstance);
            setUrbanizaciones(response || []);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar urbanizaciones.', life: 3500 });
        }
    }, [axiosInstance]);

    const cargarUrbanizacionesPaginado = useCallback(async () => {
        setUrbanizacionLoading(true);
        try {
            const response = await UrbanizacionService.listarPaginado(
                urbanizacionPage,
                urbanizacionRows,
                urbanizacionFilter,
                axiosInstance
            );
            setUrbanizacionRecords(response?.content || []);
            setUrbanizacionTotalRecords(response?.totalElements || 0);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar urbanizaciones.', life: 3500 });
        } finally {
            setUrbanizacionLoading(false);
        }
    }, [axiosInstance, urbanizacionFilter, urbanizacionPage, urbanizacionRows]);

    const cargarEtapas = useCallback(async () => {
        try {
            const response = await EtapaService.listar(axiosInstance);
            setEtapas(response || []);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar etapas.', life: 3500 });
        }
    }, [axiosInstance]);

    const cargarEtapasPaginado = useCallback(async () => {
        setEtapaLoading(true);
        try {
            const response = await EtapaService.listarPaginado(
                etapaPage,
                etapaRows,
                etapaFilter,
                etapaUrbanizacionFilter?.id ?? null,
                axiosInstance
            );
            setEtapaRecords(response?.content || []);
            setEtapaTotalRecords(response?.totalElements || 0);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar etapas.', life: 3500 });
        } finally {
            setEtapaLoading(false);
        }
    }, [axiosInstance, etapaFilter, etapaPage, etapaRows, etapaUrbanizacionFilter]);

    const cargarManzanas = useCallback(async () => {
        try {
            const response = await ManzanaService.listar(axiosInstance);
            setManzanas(response || []);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar manzanas.', life: 3500 });
        }
    }, [axiosInstance]);

    const cargarManzanasPaginado = useCallback(async () => {
        setManzanaLoading(true);
        try {
            const response = await ManzanaService.listarPaginado(
                manzanaPage,
                manzanaRows,
                manzanaFilter,
                manzanaEtapaFilter?.id ?? null,
                manzanaUrbanizacionFilter?.id ?? null,
                axiosInstance
            );
            setManzanaRecords(response?.content || []);
            setManzanaTotalRecords(response?.totalElements || 0);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar manzanas.', life: 3500 });
        } finally {
            setManzanaLoading(false);
        }
    }, [axiosInstance, manzanaEtapaFilter, manzanaFilter, manzanaPage, manzanaRows, manzanaUrbanizacionFilter]);

    const cargarLotes = useCallback(async () => {
        try {
            const response = await LoteService.listar(axiosInstance);
            setLotes(response || []);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar lotes.', life: 3500 });
        }
    }, [axiosInstance]);

    const cargarLotesPaginado = useCallback(async () => {
        setLoteLoading(true);
        try {
            const response = await LoteService.listarPaginado(
                lotePage,
                loteRows,
                loteFilter,
                loteManzanaFilter?.id ?? null,
                loteEtapaFilter?.id ?? null,
                loteUrbanizacionFilter?.id ?? null,
                axiosInstance
            );
            setLoteRecords(response?.content || []);
            setLoteTotalRecords(response?.totalElements || 0);
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar lotes.', life: 3500 });
        } finally {
            setLoteLoading(false);
        }
    }, [axiosInstance, loteFilter, loteManzanaFilter, loteEtapaFilter, loteUrbanizacionFilter, lotePage, loteRows]);

    const cargarEtapasPorUrbanizacion = useCallback(
        async (urbanizacionId) => {
            try {
                const response = await EtapaService.listarPorUrbanizacion(urbanizacionId, axiosInstance);
                return response || [];
            } catch (error) {
                console.error(error);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar etapas filtradas.', life: 3500 });
                return [];
            }
        },
        [axiosInstance]
    );

    const cargarManzanasPorEtapa = useCallback(
        async (etapaId) => {
            try {
                const response = await ManzanaService.listarPorEtapa(etapaId, axiosInstance);
                return response || [];
            } catch (error) {
                console.error(error);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar manzanas filtradas.', life: 3500 });
                return [];
            }
        },
        [axiosInstance]
    );

    useEffect(() => {
        cargarUrbanizaciones();
        cargarEtapas();
        cargarManzanas();
        cargarLotes();
    }, [cargarUrbanizaciones, cargarEtapas, cargarManzanas, cargarLotes]);

    useEffect(() => {
        cargarUrbanizacionesPaginado();
    }, [cargarUrbanizacionesPaginado]);

    useEffect(() => {
        cargarEtapasPaginado();
    }, [cargarEtapasPaginado]);

    useEffect(() => {
        cargarManzanasPaginado();
    }, [cargarManzanasPaginado]);

    useEffect(() => {
        cargarLotesPaginado();
    }, [cargarLotesPaginado]);

    useEffect(() => {
        let active = true;

        const loadEtapas = async () => {
            if (!manzanaUrbanizacion?.id) {
                setManzanaEtapas([]);
                setManzana((prev) => ({ ...prev, etapa: null }));
                return;
            }
            const response = await cargarEtapasPorUrbanizacion(manzanaUrbanizacion.id);
            if (active) {
                setManzanaEtapas(response);
            }
        };

        loadEtapas();

        return () => {
            active = false;
        };
    }, [manzanaUrbanizacion, cargarEtapasPorUrbanizacion]);

    useEffect(() => {
        let active = true;

        const loadEtapas = async () => {
            if (!manzanaDialogUrbanizacion?.id) {
                setManzanaDialogEtapas([]);
                setManzanaEdit((prev) => ({ ...prev, etapa: null }));
                return;
            }
            const response = await cargarEtapasPorUrbanizacion(manzanaDialogUrbanizacion.id);
            if (active) {
                setManzanaDialogEtapas(response);
            }
        };

        loadEtapas();

        return () => {
            active = false;
        };
    }, [manzanaDialogUrbanizacion, cargarEtapasPorUrbanizacion]);

    useEffect(() => {
        let active = true;

        const loadEtapas = async () => {
            if (!loteUrbanizacionFilter?.id) {
                setLoteFilterEtapas([]);
                setLoteEtapaFilter(null);
                setLoteFilterManzanas([]);
                setLoteManzanaFilter(null);
                return;
            }
            const response = await cargarEtapasPorUrbanizacion(loteUrbanizacionFilter.id);
            if (active) {
                setLoteFilterEtapas(response);
            }
        };

        loadEtapas();

        return () => {
            active = false;
        };
    }, [loteUrbanizacionFilter, cargarEtapasPorUrbanizacion]);

    useEffect(() => {
        let active = true;

        const loadManzanas = async () => {
            if (!loteEtapaFilter?.id) {
                setLoteFilterManzanas([]);
                setLoteManzanaFilter(null);
                return;
            }
            const response = await cargarManzanasPorEtapa(loteEtapaFilter.id);
            if (active) {
                setLoteFilterManzanas(response);
            }
        };

        loadManzanas();

        return () => {
            active = false;
        };
    }, [loteEtapaFilter, cargarManzanasPorEtapa]);

    useEffect(() => {
        let active = true;

        const loadEtapas = async () => {
            if (!manzanaUrbanizacionFilter?.id) {
                setManzanaFilterEtapas([]);
                setManzanaEtapaFilter(null);
                return;
            }
            const response = await cargarEtapasPorUrbanizacion(manzanaUrbanizacionFilter.id);
            if (active) {
                setManzanaFilterEtapas(response);
            }
        };

        loadEtapas();

        return () => {
            active = false;
        };
    }, [manzanaUrbanizacionFilter, cargarEtapasPorUrbanizacion]);

    useEffect(() => {
        let active = true;

        const loadEtapas = async () => {
            if (!loteUrbanizacion?.id) {
                setLoteEtapas([]);
                setLoteEtapa(null);
                setLoteManzanas([]);
                setLote((prev) => ({ ...prev, manzana: null }));
                return;
            }
            const response = await cargarEtapasPorUrbanizacion(loteUrbanizacion.id);
            if (active) {
                setLoteEtapas(response);
            }
        };

        loadEtapas();

        return () => {
            active = false;
        };
    }, [loteUrbanizacion, cargarEtapasPorUrbanizacion]);

    useEffect(() => {
        let active = true;

        const loadManzanas = async () => {
            if (!loteEtapa?.id) {
                setLoteManzanas([]);
                setLote((prev) => ({ ...prev, manzana: null }));
                return;
            }
            const response = await cargarManzanasPorEtapa(loteEtapa.id);
            if (active) {
                setLoteManzanas(response);
            }
        };

        loadManzanas();

        return () => {
            active = false;
        };
    }, [loteEtapa, cargarManzanasPorEtapa]);

    useEffect(() => {
        let active = true;

        const loadEtapas = async () => {
            if (!loteDialogUrbanizacion?.id) {
                setLoteDialogEtapas([]);
                setLoteDialogEtapa(null);
                setLoteDialogManzanas([]);
                setLoteEdit((prev) => ({ ...prev, manzana: null }));
                return;
            }
            const response = await cargarEtapasPorUrbanizacion(loteDialogUrbanizacion.id);
            if (active) {
                setLoteDialogEtapas(response);
            }
        };

        loadEtapas();

        return () => {
            active = false;
        };
    }, [loteDialogUrbanizacion, cargarEtapasPorUrbanizacion]);

    useEffect(() => {
        let active = true;

        const loadManzanas = async () => {
            if (!loteDialogEtapa?.id) {
                setLoteDialogManzanas([]);
                setLoteEdit((prev) => ({ ...prev, manzana: null }));
                return;
            }
            const response = await cargarManzanasPorEtapa(loteDialogEtapa.id);
            if (active) {
                setLoteDialogManzanas(response);
            }
        };

        loadManzanas();

        return () => {
            active = false;
        };
    }, [loteDialogEtapa, cargarManzanasPorEtapa]);

    const saveUrbanizacionForm = async () => {
        setUrbanizacionSubmitted(true);
        if (!urbanizacion.nombre) {
            return;
        }

        try {
            if (urbanizacion.id) {
                await UrbanizacionService.actualizar(urbanizacion.id, urbanizacion, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Urbanizacion actualizada.', life: 3000 });
            } else {
                await UrbanizacionService.crear(urbanizacion, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Urbanizacion creada.', life: 3000 });
            }

            await cargarUrbanizaciones();
            await cargarUrbanizacionesPaginado();
            setUrbanizacion(emptyUrbanizacion);
            setUrbanizacionSubmitted(false);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar la urbanizacion.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const saveUrbanizacion = async () => {
        setUrbanizacionSubmitted(true);
        if (!urbanizacionEdit.nombre) {
            return;
        }

        try {
            if (urbanizacionEdit.id) {
                await UrbanizacionService.actualizar(urbanizacionEdit.id, urbanizacionEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Urbanizacion actualizada.', life: 3000 });
            } else {
                await UrbanizacionService.crear(urbanizacionEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Urbanizacion creada.', life: 3000 });
            }

            await cargarUrbanizaciones();
            await cargarUrbanizacionesPaginado();
            setUrbanizacionDialog(false);
            setUrbanizacionEdit(emptyUrbanizacion);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar la urbanizacion.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const saveEtapaForm = async () => {
        setEtapaSubmitted(true);
        if (!etapa.nombre || !etapa.urbanizacion) {
            return;
        }

        try {
            if (etapa.id) {
                await EtapaService.actualizar(etapa.id, etapa, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Etapa actualizada.', life: 3000 });
            } else {
                await EtapaService.crear(etapa, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Etapa creada.', life: 3000 });
            }
            await cargarEtapas();
            await cargarEtapasPaginado();
            setEtapa(emptyEtapa);
            setEtapaSubmitted(false);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar la etapa.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const saveEtapa = async () => {
        setEtapaSubmitted(true);
        if (!etapaEdit.nombre || !etapaEdit.urbanizacion) {
            return;
        }

        try {
            if (etapaEdit.id) {
                await EtapaService.actualizar(etapaEdit.id, etapaEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Etapa actualizada.', life: 3000 });
            } else {
                await EtapaService.crear(etapaEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Etapa creada.', life: 3000 });
            }
            await cargarEtapas();
            await cargarEtapasPaginado();
            setEtapaDialog(false);
            setEtapaEdit(emptyEtapa);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar la etapa.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const saveManzanaForm = async () => {
        setManzanaSubmitted(true);
        if (!manzana.nombre || !manzana.etapa) {
            return;
        }

        try {
            if (manzana.id) {
                await ManzanaService.actualizar(manzana.id, manzana, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Manzana actualizada.', life: 3000 });
            } else {
                await ManzanaService.crear(manzana, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Manzana creada.', life: 3000 });
            }
            await cargarManzanas();
            await cargarManzanasPaginado();
            setManzana(emptyManzana);
            setManzanaUrbanizacion(null);
            setManzanaEtapas([]);
            setManzanaSubmitted(false);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar la manzana.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const saveManzana = async () => {
        setManzanaSubmitted(true);
        if (!manzanaEdit.nombre || !manzanaEdit.etapa) {
            return;
        }

        try {
            if (manzanaEdit.id) {
                await ManzanaService.actualizar(manzanaEdit.id, manzanaEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Manzana actualizada.', life: 3000 });
            } else {
                await ManzanaService.crear(manzanaEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Manzana creada.', life: 3000 });
            }
            await cargarManzanas();
            await cargarManzanasPaginado();
            setManzanaDialog(false);
            setManzanaEdit(emptyManzana);
            setManzanaDialogUrbanizacion(null);
            setManzanaDialogEtapas([]);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar la manzana.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const saveLoteForm = async () => {
        setLoteSubmitted(true);
        if (!lote.numero || !lote.manzana || !lote.area || !lote.precioMetroCuadrado || !lote.precioVenta) {
            return;
        }

        try {
            if (lote.id) {
                await LoteService.actualizar(lote.id, lote, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Lote actualizado.', life: 3000 });
            } else {
                await LoteService.crear(lote, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Lote creado.', life: 3000 });
            }
            await cargarLotes();
            await cargarLotesPaginado();
            setLote(emptyLote);
            setLoteUrbanizacion(null);
            setLoteEtapa(null);
            setLoteEtapas([]);
            setLoteManzanas([]);
            setLoteSubmitted(false);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar el lote.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const saveLote = async () => {
        setLoteSubmitted(true);
        if (!loteEdit.numero || !loteEdit.manzana || !loteEdit.area || !loteEdit.precioMetroCuadrado || !loteEdit.precioVenta) {
            return;
        }

        try {
            if (loteEdit.id) {
                await LoteService.actualizar(loteEdit.id, loteEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Actualizado', detail: 'Lote actualizado.', life: 3000 });
            } else {
                await LoteService.crear(loteEdit, axiosInstance);
                toast.current?.show({ severity: 'success', summary: 'Creado', detail: 'Lote creado.', life: 3000 });
            }
            await cargarLotes();
            await cargarLotesPaginado();
            setLoteDialog(false);
            setLoteEdit(emptyLote);
            setLoteDialogUrbanizacion(null);
            setLoteDialogEtapa(null);
            setLoteDialogEtapas([]);
            setLoteDialogManzanas([]);
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo guardar el lote.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const editUrbanizacion = (rowData) => {
        setUrbanizacionEdit({ ...rowData });
        setUrbanizacionSubmitted(false);
        setUrbanizacionDialog(true);
    };

    const editEtapa = (rowData) => {
        setEtapaEdit({ ...rowData });
        setEtapaSubmitted(false);
        setEtapaDialog(true);
    };

    const editManzana = (rowData) => {
        setManzanaEdit({ ...rowData });
        setManzanaDialogUrbanizacion(rowData?.etapa?.urbanizacion || null);
        setManzanaSubmitted(false);
        setManzanaDialog(true);
    };

    const editLote = (rowData) => {
        setLoteEdit({ ...rowData });
        setLoteDialogUrbanizacion(rowData?.manzana?.etapa?.urbanizacion || null);
        setLoteDialogEtapa(rowData?.manzana?.etapa || null);
        setLoteSubmitted(false);
        setLoteDialog(true);
    };

    const confirmDelete = (message, onAccept) => {
        confirmDialog({
            message,
            header: 'Confirmar Eliminacion',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si, eliminar',
            rejectLabel: 'No',
            accept: onAccept
        });
    };

    const deleteUrbanizacion = async (rowData) => {
        try {
            await UrbanizacionService.eliminar(rowData.id, axiosInstance);
            await cargarUrbanizaciones();
            await cargarUrbanizacionesPaginado();
            toast.current?.show({ severity: 'success', summary: 'Eliminado', detail: 'Urbanizacion eliminada.', life: 3000 });
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo eliminar la urbanizacion.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const deleteEtapa = async (rowData) => {
        try {
            await EtapaService.eliminar(rowData.id, axiosInstance);
            await cargarEtapas();
            await cargarEtapasPaginado();
            toast.current?.show({ severity: 'success', summary: 'Eliminado', detail: 'Etapa eliminada.', life: 3000 });
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo eliminar la etapa.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const deleteManzana = async (rowData) => {
        try {
            await ManzanaService.eliminar(rowData.id, axiosInstance);
            await cargarManzanas();
            await cargarManzanasPaginado();
            toast.current?.show({ severity: 'success', summary: 'Eliminado', detail: 'Manzana eliminada.', life: 3000 });
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo eliminar la manzana.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const deleteLote = async (rowData) => {
        try {
            await LoteService.eliminar(rowData.id, axiosInstance);
            await cargarLotes();
            await cargarLotesPaginado();
            toast.current?.show({ severity: 'success', summary: 'Eliminado', detail: 'Lote eliminado.', life: 3000 });
        } catch (error) {
            console.error(error);
            const detail = error?.response?.data?.message || 'No se pudo eliminar el lote.';
            toast.current?.show({ severity: 'error', summary: 'Error', detail, life: 4500 });
        }
    };

    const actionBodyTemplate = (rowData, onEdit, onDelete) => (
        <div className="action-buttons">
            <Button icon="pi pi-pencil" className="btn-edit" onClick={() => onEdit(rowData)} tooltip="Editar" />
            <Button icon="pi pi-trash" className="btn-delete" onClick={() => onDelete(rowData)} tooltip="Eliminar" />
        </div>
    );

    const exportCSVLote = () => {
        if (!lotes || lotes.length === 0) {
            toast.current?.show({ severity: 'warn', summary: 'Exportar', detail: 'No hay datos para exportar.', life: 3000 });
            return;
        }

        const headers = ['ID', 'Numero', 'Urbanizacion', 'Etapa', 'Manzana', 'Area', 'Precio m2', 'Costo', 'Precio venta', 'Estado'];
        const csvRows = [headers.join(',')];

        lotes.forEach(l => {
            const row = [
                l.id || '',
                l.numero || '',
                l.manzana?.etapa?.urbanizacion?.nombre || '',
                l.manzana?.etapa?.nombre || '',
                l.manzana?.nombre || '',
                l.area || '',
                l.precioMetroCuadrado || '',
                l.precioCosto || '',
                l.precioVenta || '',
                l.estadoVenta || ''
            ];
            const escapedRow = row.map(val => {
                let str = String(val);
                if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                    str = '"' + str.replace(/"/g, '""') + '"';
                }
                return str;
            });
            csvRows.push(escapedRow.join(','));
        });

        const blob = new Blob(["\uFEFF" + csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'Lotes.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const indexBodyTemplate = (_, options) => (options.rowIndex ?? 0) + 1;
    const urbanizacionIndexBodyTemplate = (_, options) => urbanizacionPage * urbanizacionRows + (options.rowIndex ?? 0) + 1;
    const etapaIndexBodyTemplate = (_, options) => etapaPage * etapaRows + (options.rowIndex ?? 0) + 1;
    const manzanaIndexBodyTemplate = (_, options) => manzanaPage * manzanaRows + (options.rowIndex ?? 0) + 1;
    const loteIndexBodyTemplate = (_, options) => lotePage * loteRows + (options.rowIndex ?? 0) + 1;

    const formatNumber = (value) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        const numericValue = Number(value);
        if (Number.isNaN(numericValue)) {
            return value;
        }
        return new Intl.NumberFormat('es-PE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(numericValue);
    };

    const formatArea = (rowData) => {
        const formatted = formatNumber(rowData?.area);
        return formatted ? `${formatted} m2` : '';
    };

    const formatPrecio = (rowData) => {
        const formatted = formatNumber(rowData?.precioVenta);
        return formatted ? `S/. ${formatted}` : '';
    };

    const formatPrecioCosto = (rowData) => {
        const formatted = formatNumber(rowData?.precioCosto);
        return formatted ? `S/. ${formatted}` : '';
    };

    const parseNumber = (value) => {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        const numericValue = Number(value);
        return Number.isNaN(numericValue) ? null : numericValue;
    };

    const recalcularCosto = async (areaValue, precioMetroValue, setter) => {
        const area = parseNumber(areaValue);
        const precioMetroCuadrado = parseNumber(precioMetroValue);
        if (!area || !precioMetroCuadrado) {
            setter((prev) => ({ ...prev, precioCosto: null }));
            return;
        }
        try {
            const response = await LoteService.calcularCosto(area, precioMetroCuadrado, axiosInstance);
            setter((prev) => ({ ...prev, precioCosto: response?.precioCosto ?? null }));
        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: 'warn', summary: 'Costo', detail: 'No se pudo calcular el costo.', life: 3000 });
        }
    };

    const formActions = (onSave, onReset) => (
        <div className="lotizacion-actions">
            <Button label="Limpiar" icon="pi pi-refresh" className="p-button-outlined" onClick={onReset} />
            <Button label="Guardar" icon="pi pi-check" onClick={onSave} />
        </div>
    );

    return (
        <div className="usuario-page lotizacion-page">
            <Toast ref={toast} />
            <div className="container">
                <PageHeader
                    title="Lotizacion"
                    description="Administra urbanizacion, etapa, manzana y lote."
                    icon="pi pi-sitemap"
                />

                <div className="main-content">
                    <TabView className="lotizacion-entity-tabs">
                        <TabPanel header="Urbanizacion" leftIcon="pi pi-home mr-2">
                            <div className="lotizacion-form-layout">
                                <div className="content-card lotizacion-form-card">
                                    <h5 className="lotizacion-form-title">Registro de urbanizacion</h5>
                                    <div className="field">
                                        <label htmlFor="urbanizacionNombre">Nombre</label>
                                        <InputText
                                            id="urbanizacionNombre"
                                            value={urbanizacion.nombre}
                                            onChange={(e) => setUrbanizacion((prev) => ({ ...prev, nombre: e.target.value }))}
                                            placeholder="Nombre de urbanizacion"
                                        />
                                        {urbanizacionSubmitted && !urbanizacion.nombre && <small className="p-error">Nombre requerido.</small>}
                                    </div>
                                    <div className="field">
                                        <label htmlFor="urbanizacionUbicacion">Ubicacion</label>
                                        <InputText
                                            id="urbanizacionUbicacion"
                                            value={urbanizacion.ubicacion}
                                            onChange={(e) => setUrbanizacion((prev) => ({ ...prev, ubicacion: e.target.value }))}
                                            placeholder="Ubicacion"
                                        />
                                    </div>
                                    {formActions(saveUrbanizacionForm, () => setUrbanizacion(emptyUrbanizacion))}
                                </div>
                                <div className="content-card lotizacion-list-card">
                                    <ActionToolbar
                                        onSearch={(value) => {
                                            setUrbanizacionFilter(value);
                                            setUrbanizacionPage(0);
                                        }}
                                        searchValue={urbanizacionFilter}
                                        searchPlaceholder="Buscar urbanizaciones..."
                                    />
                                    <DataTable
                                        value={urbanizacionRecords}
                                        dataKey="id"
                                        rows={urbanizacionRows}
                                        first={urbanizacionPage * urbanizacionRows}
                                        paginator
                                        rowsPerPageOptions={[6, 10, 20, 50]}
                                        lazy
                                        totalRecords={urbanizacionTotalRecords}
                                        loading={urbanizacionLoading}
                                        onPage={(event) => {
                                            setUrbanizacionPage(event.page ?? 0);
                                            setUrbanizacionRows(event.rows ?? urbanizacionRows);
                                        }}
                                        emptyMessage="No se encontraron urbanizaciones."
                                    >
                                        <Column header="N°" body={urbanizacionIndexBodyTemplate} style={{ width: '80px', textAlign: 'center' }} />
                                        <Column field="nombre" header="Nombre" style={{ minWidth: '200px' }} />
                                        <Column field="ubicacion" header="Ubicacion" style={{ minWidth: '200px' }} />
                                        <Column header="Acciones" body={(rowData) => actionBodyTemplate(rowData, editUrbanizacion, (data) => confirmDelete('Eliminar urbanizacion?', () => deleteUrbanizacion(data)))} style={{ minWidth: '140px', textAlign: 'center' }} />
                                    </DataTable>
                                </div>
                            </div>
                        </TabPanel>

                        <TabPanel header="Etapa" leftIcon="pi pi-clone mr-2">
                            <div className="lotizacion-form-layout">
                                <div className="content-card lotizacion-form-card">
                                    <h5 className="lotizacion-form-title">Registro de etapa</h5>
                                    <div className="field">
                                        <label htmlFor="etapaUrbanizacion">Urbanizacion</label>
                                        <Dropdown
                                            id="etapaUrbanizacion"
                                            value={etapa.urbanizacion}
                                            options={urbanizacionOptions}
                                            onChange={(e) => setEtapa((prev) => ({ ...prev, urbanizacion: e.value }))}
                                            placeholder="Seleccione urbanizacion"
                                            className="w-full"
                                            showClear
                                        />
                                        {etapaSubmitted && !etapa.urbanizacion && <small className="p-error">Urbanizacion requerida.</small>}
                                    </div>
                                    <div className="field">
                                        <label htmlFor="etapaNombre">Nombre</label>
                                        <InputText
                                            id="etapaNombre"
                                            value={etapa.nombre}
                                            onChange={(e) => setEtapa((prev) => ({ ...prev, nombre: e.target.value }))}
                                            placeholder="Nombre de etapa"
                                        />
                                        {etapaSubmitted && !etapa.nombre && <small className="p-error">Nombre requerido.</small>}
                                    </div>
                                    {formActions(saveEtapaForm, () => setEtapa(emptyEtapa))}
                                </div>
                                <div className="content-card lotizacion-list-card">
                                    <div className="action-toolbar">
                                        <div className="toolbar-actions flex align-items-center gap-2">
                                            <Dropdown
                                                value={etapaUrbanizacionFilter}
                                                options={urbanizacionOptions}
                                                onChange={(e) => {
                                                    setEtapaUrbanizacionFilter(e.value || null);
                                                    setEtapaPage(0);
                                                }}
                                                placeholder="Filtrar por urbanizacion"
                                                className="w-full"
                                                showClear
                                            />
                                        </div>
                                        <div className="toolbar-actions flex align-items-center gap-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search" style={{ color: 'var(--text-secondary)' }} />
                                                <InputText
                                                    type="search"
                                                    value={etapaFilter || ''}
                                                    onChange={(e) => {
                                                        setEtapaFilter(e.target.value);
                                                        setEtapaPage(0);
                                                    }}
                                                    placeholder="Buscar etapas..."
                                                    className="search-input"
                                                    style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: 'var(--bg-page)', color: 'var(--text-primary)' }}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    <DataTable
                                        value={etapaRecords}
                                        dataKey="id"
                                        rows={etapaRows}
                                        first={etapaPage * etapaRows}
                                        paginator
                                        rowsPerPageOptions={[6, 10, 20, 50]}
                                        lazy
                                        totalRecords={etapaTotalRecords}
                                        loading={etapaLoading}
                                        onPage={(event) => {
                                            setEtapaPage(event.page ?? 0);
                                            setEtapaRows(event.rows ?? etapaRows);
                                        }}
                                        emptyMessage="No se encontraron etapas."
                                    >
                                        <Column header="N°" body={etapaIndexBodyTemplate} style={{ width: '80px', textAlign: 'center' }} />
                                        <Column field="nombre" header="Nombre" style={{ minWidth: '200px' }} />
                                        <Column field="urbanizacion.nombre" header="Urbanizacion" style={{ minWidth: '200px' }} />
                                        <Column header="Acciones" body={(rowData) => actionBodyTemplate(rowData, editEtapa, (data) => confirmDelete('Eliminar etapa?', () => deleteEtapa(data)))} style={{ minWidth: '140px', textAlign: 'center' }} />
                                    </DataTable>
                                </div>
                            </div>
                        </TabPanel>

                        <TabPanel header="Manzana" leftIcon="pi pi-th-large mr-2">
                            <div className="lotizacion-form-layout">
                                <div className="content-card lotizacion-form-card">
                                    <h5 className="lotizacion-form-title">Registro de manzana</h5>
                                    <div className="field">
                                        <label htmlFor="manzanaUrbanizacion">Urbanizacion</label>
                                        <Dropdown
                                            id="manzanaUrbanizacion"
                                            value={manzanaUrbanizacion}
                                            options={urbanizacionOptions}
                                            onChange={(e) => {
                                                setManzanaUrbanizacion(e.value);
                                                setManzana((prev) => ({ ...prev, etapa: null }));
                                            }}
                                            placeholder="Seleccione urbanizacion"
                                            className="w-full"
                                            showClear
                                        />
                                    </div>
                                    <div className="field">
                                        <label htmlFor="manzanaEtapa">Etapa</label>
                                        <Dropdown
                                            id="manzanaEtapa"
                                            value={manzana.etapa}
                                            options={manzanaEtapaOptions}
                                            onChange={(e) => setManzana((prev) => ({ ...prev, etapa: e.value }))}
                                            placeholder="Seleccione etapa"
                                            className="w-full"
                                            showClear
                                            disabled={!manzanaUrbanizacion}
                                        />
                                        {manzanaSubmitted && !manzana.etapa && <small className="p-error">Etapa requerida.</small>}
                                    </div>
                                    <div className="field">
                                        <label htmlFor="manzanaNombre">Nombre</label>
                                        <InputText
                                            id="manzanaNombre"
                                            value={manzana.nombre}
                                            onChange={(e) => setManzana((prev) => ({ ...prev, nombre: e.target.value }))}
                                            placeholder="Nombre de manzana"
                                        />
                                        {manzanaSubmitted && !manzana.nombre && <small className="p-error">Nombre requerido.</small>}
                                    </div>
                                    {formActions(saveManzanaForm, () => {
                                        setManzana(emptyManzana);
                                        setManzanaUrbanizacion(null);
                                        setManzanaEtapas([]);
                                    })}
                                </div>
                                <div className="content-card lotizacion-list-card">
                                    <div className="action-toolbar">
                                        <div className="toolbar-actions flex align-items-center gap-2">
                                            <Dropdown
                                                value={manzanaUrbanizacionFilter}
                                                options={urbanizacionOptions}
                                                onChange={(e) => {
                                                    setManzanaUrbanizacionFilter(e.value || null);
                                                    setManzanaEtapaFilter(null);
                                                    setManzanaPage(0);
                                                }}
                                                placeholder="Filtrar por urbanizacion"
                                                className="w-full"
                                                showClear
                                            />
                                            <Dropdown
                                                value={manzanaEtapaFilter}
                                                options={manzanaFilterEtapaOptions}
                                                onChange={(e) => {
                                                    setManzanaEtapaFilter(e.value || null);
                                                    setManzanaPage(0);
                                                }}
                                                placeholder="Filtrar por etapa"
                                                className="w-full"
                                                showClear
                                                disabled={!manzanaUrbanizacionFilter}
                                            />
                                        </div>
                                        <div className="toolbar-actions flex align-items-center gap-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search" style={{ color: 'var(--text-secondary)' }} />
                                                <InputText
                                                    type="search"
                                                    value={manzanaFilter || ''}
                                                    onChange={(e) => {
                                                        setManzanaFilter(e.target.value);
                                                        setManzanaPage(0);
                                                    }}
                                                    placeholder="Buscar manzanas..."
                                                    className="search-input"
                                                    style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: 'var(--bg-page)', color: 'var(--text-primary)' }}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    <DataTable
                                        value={manzanaRecords}
                                        dataKey="id"
                                        rows={manzanaRows}
                                        first={manzanaPage * manzanaRows}
                                        paginator
                                        rowsPerPageOptions={[6, 10, 20, 50]}
                                        lazy
                                        totalRecords={manzanaTotalRecords}
                                        loading={manzanaLoading}
                                        onPage={(event) => {
                                            setManzanaPage(event.page ?? 0);
                                            setManzanaRows(event.rows ?? manzanaRows);
                                        }}
                                        emptyMessage="No se encontraron manzanas."
                                    >
                                        <Column header="N°" body={manzanaIndexBodyTemplate} style={{ width: '80px', textAlign: 'center' }} />
                                        <Column field="nombre" header="Nombre" style={{ minWidth: '200px' }} />
                                        <Column field="etapa.urbanizacion.nombre" header="Urbanizacion" style={{ minWidth: '200px' }} />
                                        <Column field="etapa.nombre" header="Etapa" style={{ minWidth: '200px' }} />
                                        <Column field="areaTotal" header="Area Total (m²)" style={{ minWidth: '150px' }} />
                                        <Column header="Acciones" body={(rowData) => actionBodyTemplate(rowData, editManzana, (data) => confirmDelete('Eliminar manzana?', () => deleteManzana(data)))} style={{ minWidth: '140px', textAlign: 'center' }} />
                                    </DataTable>
                                </div>
                            </div>
                        </TabPanel>

                        <TabPanel header="Lote" leftIcon="pi pi-map mr-2">
                            <div className="lotizacion-form-layout lotizacion-form-layout--stack">
                                <div className="content-card lotizacion-form-card lotizacion-form-card--grid">
                                    <div className="lotizacion-form-title-group">
                                        <h5 className="lotizacion-form-title">Registro de lote</h5>
                                        <small className="lotizacion-form-hint">Primero seleccione urbanizacion, etapa y manzana.</small>
                                    </div>
                                    <div className="lotizacion-lote-select">
                                        <div className="field">
                                            <label htmlFor="loteUrbanizacion">Urbanizacion</label>
                                            <Dropdown
                                                id="loteUrbanizacion"
                                                value={loteUrbanizacion}
                                                options={urbanizacionOptions}
                                                onChange={(e) => {
                                                    setLoteUrbanizacion(e.value);
                                                    setLoteEtapa(null);
                                                    setLote((prev) => ({ ...prev, manzana: null }));
                                                }}
                                                placeholder="Seleccione urbanizacion"
                                                className="w-full"
                                                showClear
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="loteEtapa">Etapa</label>
                                            <Dropdown
                                                id="loteEtapa"
                                                value={loteEtapa}
                                                options={loteEtapaOptions}
                                                onChange={(e) => {
                                                    setLoteEtapa(e.value);
                                                    setLote((prev) => ({ ...prev, manzana: null }));
                                                }}
                                                placeholder="Seleccione etapa"
                                                className="w-full"
                                                showClear
                                                disabled={!loteUrbanizacion}
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="loteManzana">Manzana</label>
                                            <Dropdown
                                                id="loteManzana"
                                                value={lote.manzana}
                                                options={loteManzanaOptions}
                                                onChange={(e) => setLote((prev) => ({ ...prev, manzana: e.value }))}
                                                placeholder="Seleccione manzana"
                                                className="w-full"
                                                showClear
                                                disabled={!loteEtapa}
                                            />
                                            {loteSubmitted && !lote.manzana && <small className="p-error">Manzana requerida.</small>}
                                        </div>
                                    </div>
                                    <div className="lotizacion-lote-details">
                                        <div className="field">
                                            <label htmlFor="loteNumero">Numero</label>
                                            <InputText
                                                id="loteNumero"
                                                value={lote.numero}
                                                onChange={(e) => setLote((prev) => ({ ...prev, numero: e.target.value }))}
                                                placeholder="Numero de lote"
                                            />
                                            {loteSubmitted && !lote.numero && <small className="p-error">Numero requerido.</small>}
                                        </div>
                                        <div className="field">
                                            <label htmlFor="loteArea">Area</label>
                                            <InputText
                                                id="loteArea"
                                                value={lote.area || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setLote((prev) => ({ ...prev, area: value }));
                                                    recalcularCosto(value, lote.precioMetroCuadrado, setLote);
                                                }}
                                                placeholder="Area"
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="lotePrecioMetro">Precio m2</label>
                                            <InputText
                                                id="lotePrecioMetro"
                                                value={lote.precioMetroCuadrado || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setLote((prev) => ({ ...prev, precioMetroCuadrado: value }));
                                                    recalcularCosto(lote.area, value, setLote);
                                                }}
                                                placeholder="Precio m2"
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="lotePrecioCosto">Precio costo</label>
                                            <InputText
                                                id="lotePrecioCosto"
                                                value={lote.precioCosto || ''}
                                                onChange={(e) => setLote((prev) => ({ ...prev, precioCosto: e.target.value }))}
                                                placeholder="Precio costo"
                                                disabled
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="lotePrecioVenta">Precio venta</label>
                                            <InputText
                                                id="lotePrecioVenta"
                                                value={lote.precioVenta || ''}
                                                onChange={(e) => setLote((prev) => ({ ...prev, precioVenta: e.target.value }))}
                                                placeholder="Precio venta"
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="loteEstado">Estado</label>
                                            <Dropdown
                                                id="loteEstado"
                                                value={lote.estadoVenta}
                                                options={EstadoLoteOptions}
                                                onChange={(e) => setLote((prev) => ({ ...prev, estadoVenta: e.value }))}
                                                placeholder="Seleccione estado"
                                                className="w-full"
                                            />
                                        </div>
                                    </div>
                                    {formActions(saveLoteForm, () => {
                                        setLote(emptyLote);
                                        setLoteUrbanizacion(null);
                                        setLoteEtapa(null);
                                        setLoteEtapas([]);
                                        setLoteManzanas([]);
                                    })}
                                </div>
                                <div className="content-card lotizacion-list-card">
                                    <div className="action-toolbar">
                                        <div className="toolbar-actions flex align-items-center gap-2">
                                            <Dropdown
                                                value={loteUrbanizacionFilter}
                                                options={urbanizacionOptions}
                                                onChange={(e) => {
                                                    setLoteUrbanizacionFilter(e.value || null);
                                                    setLoteEtapaFilter(null);
                                                    setLoteManzanaFilter(null);
                                                    setLotePage(0);
                                                }}
                                                placeholder="Filtrar por urbanizacion"
                                                className="w-full"
                                                showClear
                                            />
                                            <Dropdown
                                                value={loteEtapaFilter}
                                                options={loteFilterEtapaOptions}
                                                onChange={(e) => {
                                                    setLoteEtapaFilter(e.value || null);
                                                    setLoteManzanaFilter(null);
                                                    setLotePage(0);
                                                }}
                                                placeholder="Filtrar por etapa"
                                                className="w-full"
                                                showClear
                                                disabled={!loteUrbanizacionFilter}
                                            />
                                            <Dropdown
                                                value={loteManzanaFilter}
                                                options={loteFilterManzanaOptions}
                                                onChange={(e) => {
                                                    setLoteManzanaFilter(e.value || null);
                                                    setLotePage(0);
                                                }}
                                                placeholder="Filtrar por manzana"
                                                className="w-full"
                                                showClear
                                                disabled={!loteEtapaFilter}
                                            />
                                        </div>
                                        <div className="toolbar-actions flex align-items-center gap-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search" style={{ color: 'var(--text-secondary)' }} />
                                                <InputText
                                                    type="search"
                                                    value={loteFilter || ''}
                                                    onChange={(e) => {
                                                        setLoteFilter(e.target.value);
                                                        setLotePage(0);
                                                    }}
                                                    placeholder="Buscar lotes..."
                                                    className="search-input"
                                                    style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: 'var(--bg-page)', color: 'var(--text-primary)' }}
                                                />
                                            </span>
                                            <Button
                                                icon="pi pi-download"
                                                tooltip="Exportar en Excel"
                                                tooltipOptions={{ position: 'bottom' }}
                                                className="btn-export p-button-outlined p-button-secondary ml-2"
                                                onClick={exportCSVLote}
                                                style={{ borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                    <DataTable
                                        ref={dtLote}
                                        value={loteRecords}
                                        dataKey="id"
                                        rows={loteRows}
                                        first={lotePage * loteRows}
                                        paginator
                                        rowsPerPageOptions={[6, 10, 20, 50]}
                                        lazy
                                        totalRecords={loteTotalRecords}
                                        loading={loteLoading}
                                        onPage={(event) => {
                                            setLotePage(event.page ?? 0);
                                            setLoteRows(event.rows ?? loteRows);
                                        }}
                                        emptyMessage="No se encontraron lotes."
                                        exportFilename="Lotes"
                                    >
                                        <Column field="numero" header="N°" style={{ minWidth: '120px' }} />
                                        <Column field="manzana.etapa.urbanizacion.nombre" header="Urbanizacion" style={{ minWidth: '200px' }} />
                                        <Column field="manzana.etapa.nombre" header="Etapa" style={{ minWidth: '160px' }} />
                                        <Column field="manzana.nombre" header="Manzana" style={{ minWidth: '160px' }} />
                                        <Column header="Area" body={formatArea} style={{ minWidth: '120px' }} />
                                        {!['ADMINISTRADORA', 'ASISTENTE_ADMINISTRATIVO'].includes(user?.role) && <Column header="Precio m2" field="precioMetroCuadrado" style={{ minWidth: '120px' }} />}
                                        {!['ADMINISTRADORA', 'ASISTENTE_ADMINISTRATIVO'].includes(user?.role) && <Column header="Costo" body={formatPrecioCosto} style={{ minWidth: '140px' }} />}
                                        <Column header="Precio venta" body={formatPrecio} style={{ minWidth: '140px' }} />
                                        <Column field="estadoVenta" header="Estado" style={{ minWidth: '140px' }} />
                                        <Column header="Acciones" body={(rowData) => actionBodyTemplate(rowData, editLote, (data) => confirmDelete('Eliminar lote?', () => deleteLote(data)))} style={{ minWidth: '140px', textAlign: 'center' }} />
                                    </DataTable>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
            </div>

            <Dialog
                visible={urbanizacionDialog}
                style={{ width: '700px', maxWidth: '95vw' }}
                header={<DialogHeader title={urbanizacionEdit.id ? 'Editar Urbanizacion' : 'Nueva Urbanizacion'} subtitle="Gestion de urbanizaciones" icon="pi pi-home" />}
                modal
                className="p-fluid custom-profile-dialog"
                onHide={hideUrbanizacionDialog}
                footer={
                    <div className="dialog-footer-buttons">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={hideUrbanizacionDialog} />
                        <Button label="Guardar" icon="pi pi-check" onClick={saveUrbanizacion} />
                    </div>
                }
            >
                <div className="formgrid grid mt-4 dialog-content-specific">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="urbanizacionNombreDialog">Nombre</label>
                        <InputText
                            id="urbanizacionNombreDialog"
                            value={urbanizacionEdit.nombre}
                            onChange={(e) => setUrbanizacionEdit((prev) => ({ ...prev, nombre: e.target.value }))}
                            required
                            placeholder="Nombre de urbanizacion"
                            className={urbanizacionSubmitted && !urbanizacionEdit.nombre ? 'p-invalid' : ''}
                        />
                        {urbanizacionSubmitted && !urbanizacionEdit.nombre && <small className="p-error">Nombre requerido.</small>}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="urbanizacionUbicacionDialog">Ubicacion</label>
                        <InputText
                            id="urbanizacionUbicacionDialog"
                            value={urbanizacionEdit.ubicacion}
                            onChange={(e) => setUrbanizacionEdit((prev) => ({ ...prev, ubicacion: e.target.value }))}
                            placeholder="Ubicacion"
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                visible={etapaDialog}
                style={{ width: '700px', maxWidth: '95vw' }}
                header={<DialogHeader title={etapaEdit.id ? 'Editar Etapa' : 'Nueva Etapa'} subtitle="Gestion de etapas" icon="pi pi-clone" />}
                modal
                className="p-fluid custom-profile-dialog"
                onHide={hideEtapaDialog}
                footer={
                    <div className="dialog-footer-buttons">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={hideEtapaDialog} />
                        <Button label="Guardar" icon="pi pi-check" onClick={saveEtapa} />
                    </div>
                }
            >
                <div className="formgrid grid mt-4 dialog-content-specific">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="etapaNombreDialog">Nombre</label>
                        <InputText
                            id="etapaNombreDialog"
                            value={etapaEdit.nombre}
                            onChange={(e) => setEtapaEdit((prev) => ({ ...prev, nombre: e.target.value }))}
                            required
                            placeholder="Nombre de etapa"
                            className={etapaSubmitted && !etapaEdit.nombre ? 'p-invalid' : ''}
                        />
                        {etapaSubmitted && !etapaEdit.nombre && <small className="p-error">Nombre requerido.</small>}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="etapaUrbanizacionDialog">Urbanizacion</label>
                        <Dropdown
                            id="etapaUrbanizacionDialog"
                            value={etapaEdit.urbanizacion}
                            options={urbanizacionOptions}
                            onChange={(e) => setEtapaEdit((prev) => ({ ...prev, urbanizacion: e.value }))}
                            placeholder="Seleccione urbanizacion"
                            className="w-full"
                            showClear
                        />
                        {etapaSubmitted && !etapaEdit.urbanizacion && <small className="p-error">Urbanizacion requerida.</small>}
                    </div>
                </div>
            </Dialog>

            <Dialog
                visible={manzanaDialog}
                style={{ width: '700px', maxWidth: '95vw' }}
                header={<DialogHeader title={manzanaEdit.id ? 'Editar Manzana' : 'Nueva Manzana'} subtitle="Gestion de manzanas" icon="pi pi-th-large" />}
                modal
                className="p-fluid custom-profile-dialog"
                onHide={hideManzanaDialog}
                footer={
                    <div className="dialog-footer-buttons">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={hideManzanaDialog} />
                        <Button label="Guardar" icon="pi pi-check" onClick={saveManzana} />
                    </div>
                }
            >
                <div className="formgrid grid mt-4 dialog-content-specific">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="manzanaNombreDialog">Nombre</label>
                        <InputText
                            id="manzanaNombreDialog"
                            value={manzanaEdit.nombre}
                            onChange={(e) => setManzanaEdit((prev) => ({ ...prev, nombre: e.target.value }))}
                            required
                            placeholder="Nombre de manzana"
                            className={manzanaSubmitted && !manzanaEdit.nombre ? 'p-invalid' : ''}
                        />
                        {manzanaSubmitted && !manzanaEdit.nombre && <small className="p-error">Nombre requerido.</small>}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="manzanaUrbanizacionDialog">Urbanizacion</label>
                        <Dropdown
                            id="manzanaUrbanizacionDialog"
                            value={manzanaDialogUrbanizacion}
                            options={urbanizacionOptions}
                            onChange={(e) => {
                                setManzanaDialogUrbanizacion(e.value);
                                setManzanaEdit((prev) => ({ ...prev, etapa: null }));
                            }}
                            placeholder="Seleccione urbanizacion"
                            className="w-full"
                            showClear
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="manzanaEtapaDialog">Etapa</label>
                        <Dropdown
                            id="manzanaEtapaDialog"
                            value={manzanaEdit.etapa}
                            options={manzanaDialogEtapaOptions}
                            onChange={(e) => setManzanaEdit((prev) => ({ ...prev, etapa: e.value }))}
                            placeholder="Seleccione etapa"
                            className="w-full"
                            showClear
                            disabled={!manzanaDialogUrbanizacion}
                        />
                        {manzanaSubmitted && !manzanaEdit.etapa && <small className="p-error">Etapa requerida.</small>}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="manzanaAreaTotalDialog">Area Total (m²)</label>
                        <InputText
                            id="manzanaAreaTotalDialog"
                            type="number"
                            value={manzanaEdit.areaTotal || ''}
                            onChange={(e) => setManzanaEdit((prev) => ({ ...prev, areaTotal: parseFloat(e.target.value) || 0 }))}
                            placeholder="Ej. 15000"
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                visible={loteDialog}
                style={{ width: '720px', maxWidth: '95vw' }}
                header={<DialogHeader title={loteEdit.id ? 'Editar Lote' : 'Nuevo Lote'} subtitle="Gestion de lotes" icon="pi pi-map" />}
                modal
                className="p-fluid custom-profile-dialog"
                onHide={hideLoteDialog}
                footer={
                    <div className="dialog-footer-buttons">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={hideLoteDialog} />
                        <Button label="Guardar" icon="pi pi-check" onClick={saveLote} />
                    </div>
                }
            >
                <div className="formgrid grid mt-4 dialog-content-specific">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="loteNumeroDialog">Numero</label>
                        <InputText
                            id="loteNumeroDialog"
                            value={loteEdit.numero}
                            onChange={(e) => setLoteEdit((prev) => ({ ...prev, numero: e.target.value }))}
                            required
                            placeholder="Numero de lote"
                            className={loteSubmitted && !loteEdit.numero ? 'p-invalid' : ''}
                        />
                        {loteSubmitted && !loteEdit.numero && <small className="p-error">Numero requerido.</small>}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="loteUrbanizacionDialog">Urbanizacion</label>
                        <Dropdown
                            id="loteUrbanizacionDialog"
                            value={loteDialogUrbanizacion}
                            options={urbanizacionOptions}
                            onChange={(e) => {
                                setLoteDialogUrbanizacion(e.value);
                                setLoteDialogEtapa(null);
                                setLoteEdit((prev) => ({ ...prev, manzana: null }));
                            }}
                            placeholder="Seleccione urbanizacion"
                            className="w-full"
                            showClear
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="loteEtapaDialog">Etapa</label>
                        <Dropdown
                            id="loteEtapaDialog"
                            value={loteDialogEtapa}
                            options={loteDialogEtapaOptions}
                            onChange={(e) => {
                                setLoteDialogEtapa(e.value);
                                setLoteEdit((prev) => ({ ...prev, manzana: null }));
                            }}
                            placeholder="Seleccione etapa"
                            className="w-full"
                            showClear
                            disabled={!loteDialogUrbanizacion}
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="loteManzanaDialog">Manzana</label>
                        <Dropdown
                            id="loteManzanaDialog"
                            value={loteEdit.manzana}
                            options={loteDialogManzanaOptions}
                            onChange={(e) => setLoteEdit((prev) => ({ ...prev, manzana: e.value }))}
                            placeholder="Seleccione manzana"
                            className="w-full"
                            showClear
                            disabled={!loteDialogEtapa}
                        />
                        {loteSubmitted && !loteEdit.manzana && <small className="p-error">Manzana requerida.</small>}
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="loteAreaDialog">Area</label>
                        <InputText
                            id="loteAreaDialog"
                            value={loteEdit.area || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setLoteEdit((prev) => ({ ...prev, area: value }));
                                recalcularCosto(value, loteEdit.precioMetroCuadrado, setLoteEdit);
                            }}
                            placeholder="Area"
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="lotePrecioMetroDialog">Precio m2</label>
                        <InputText
                            id="lotePrecioMetroDialog"
                            value={loteEdit.precioMetroCuadrado || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setLoteEdit((prev) => ({ ...prev, precioMetroCuadrado: value }));
                                recalcularCosto(loteEdit.area, value, setLoteEdit);
                            }}
                            placeholder="Precio m2"
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="lotePrecioCostoDialog">Precio costo</label>
                        <InputText
                            id="lotePrecioCostoDialog"
                            value={loteEdit.precioCosto || ''}
                            onChange={(e) => setLoteEdit((prev) => ({ ...prev, precioCosto: e.target.value }))}
                            placeholder="Precio costo"
                            disabled
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="lotePrecioVentaDialog">Precio venta</label>
                        <InputText
                            id="lotePrecioVentaDialog"
                            value={loteEdit.precioVenta || ''}
                            onChange={(e) => setLoteEdit((prev) => ({ ...prev, precioVenta: e.target.value }))}
                            placeholder="Precio venta"
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="loteEstadoDialog">Estado</label>
                        <Dropdown
                            id="loteEstadoDialog"
                            value={loteEdit.estadoVenta}
                            options={EstadoLoteOptions}
                            onChange={(e) => setLoteEdit((prev) => ({ ...prev, estadoVenta: e.value }))}
                            placeholder="Seleccione estado"
                            className="w-full"
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default Lotizacion;
